/**
 * Vesper Message Service (Shared)
 */

import apiClient from './api.client';
import { API } from '../constants/api';
import { deduped, bust } from './dedupedFetch';
import type { EventMessage, EventConversation } from '../types/message.types';

export async function getConversations(): Promise<EventConversation[]> {
  return deduped('me:eventConversations', async () => {
    const res = await apiClient.get<{ data: EventConversation[] }>(API.CONVERSATIONS);
    return res.data.data;
  });
}

export async function getEventMessages(
  eventId: string,
  before?: string,
): Promise<EventMessage[]> {
  const params = before ? `?before=${encodeURIComponent(before)}` : '';
  const res = await apiClient.get<{ data: EventMessage[] }>(
    `${API.EVENT_MESSAGES(eventId)}${params}`,
  );
  return res.data.data;
}

export async function sendEventMessage(
  eventId: string,
  content: string,
): Promise<EventMessage> {
  const res = await apiClient.post<{ data: EventMessage }>(
    API.EVENT_MESSAGES(eventId),
    { content },
  );
  // lastMessage on the conversation list changes; invalidate.
  bust('me:eventConversations');
  return res.data.data;
}
